module.exports = __webpack_public_path__ + "media/img/help_center/Student_Message_02-57e8ffa9c6683f0dbb77524224f44f07.jpg";